const tailwind = require('../tailwind')

module.exports = {
  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "/portfolio"

  siteTitle: 'Quark', // Navigation and Site Title
  siteTitleAlt: 'Quark', // Alternative Site title for SEO
  siteTitleShort: 'Quark', // short_name for manifest
  siteUrl: 'https://landing.nishkal.in', // Domain of your site. No trailing slash!
  siteLanguage: 'en', // Language Tag on <html> element
  siteLogo: '/logo.png', // Used for SEO and manifest
  siteDescription: 'An extensible platform to build graphical user interfaces for your everyday projects',

  // siteFBAppID: '123456789', // Facebook App ID - Optional
  userTwitter: '@kashyapnishkal', // Twitter Username
  ogSiteName: 'nishkal', // Facebook Site Name
  ogLanguage: 'en_US', // Facebook Language

  // Manifest and Progress color
  themeColor: tailwind.colors.orange,
  backgroundColor: tailwind.colors.blue,
}
